<po-page-list #pageListComponent [p-breadcrumb]="breadcrumb" p-title="Cadastro de Empresas"
  [p-disclaimer-group]="disclaimerGroup" [p-actions]="pageActions" [p-filter]="filterSettings"
  p-subtitle="Consulte os dados cadastrados no sistema.">
  <p class="po-font-subtitle">Verifique todas as empresas cadastradas no sistema.</p>
  <po-divider></po-divider>

  <div class="po-row po-mb-3 situacao-filtro">
    <po-radio-group
      class="po-lg-6 po-md-8 po-sm-12"
      name="situacaoFiltro"
      p-label="Situação"
      p-help="Filtra empresas ativas ou inativas (conforme Data de Inativação)."
      [p-columns]="3"
      [p-options]="situacaoOptions"
      [ngModel]="situacaoFiltro"
      (ngModelChange)="onChangeSituacao($event)">
    </po-radio-group>
  </div>

    <div class="po-row po-mb-4 shadow">
      <div>
        <po-loading-overlay [hidden]="isHideLoading"></po-loading-overlay>
      </div>
      <po-table #dynamicTable p-container="border" [p-actions]="actions" class="po-mr-1 po-ml-1 po-lg-12" #wppTable
        (p-show-more)="loadMore()" [p-show-more-disabled]="!moreItens" p-striped="true" p-text-wrap="true"
        [p-spacing]="poTableColumnSpacing" [p-loading-show-more]="!isHideLoading" p-container="border"
        p-hide-columns-manager="false" [p-columns]="columns" [p-items]="items">
      </po-table>
    </div>
  </po-page-list>

  <po-modal #modalEmpresaRpa p-size="xl" p-title="Relatório de Empresas x Rpa" p-icon="an an-tray-arrow-down"
    p-click-out="false">
    <div class="po-row">
      <div class="po-row">
        <po-container class="po-lg-12 po-md-12 po-sm-12">
          <span class="po-lg-12 po-md-12 po-sm-12 po-mb-2 po-font-text-uppercase">
            <span class="an an-robot"></span>
            Empresas sem emissão de Rpa
          </span>
          <po-select class="po-lg-3" p-label="Certidão" p-placeholder="Selecione uma certidão..."
          [p-show-required]="true" [p-required]="true" (p-change)="onChangeTipocertidao($event)" [p-options]="[
                  {
                    label: 'Trabalhista',
                    value: 'CND-TRABALHISTA'
                  },
                  {
                    label: 'Divida Ativa SP',
                    value: 'CND-DT-SP'
                  },
                  {
                    label: 'Divida Ativa (Não Inscritos) SP',
                    value: 'CND-DTNI-SP'
                  },
                  {
                    label: 'FGTS',
                    value: 'CND-FGTS'
                  },
                  {
                    label: 'Municipal',
                    value: 'CND-MUNICI'
                  }
                  ]" p-help="Informe uma certidão válida." p-required="true" p-name="certidaoSelect">
        </po-select>
        <po-select class="po-lg-3" p-label="Competência" p-placeholder="Selecione uma competencia."
          [p-show-required]="true" [p-required]="true" (p-change)="onChangeCompetencia($event)"
          [p-options]="competenciaOptions" p-help="Informe uma competência válida." p-required="true"
          p-name="certidaoSelect">
      </po-select>
      <po-combo class="po-lg-3" p-label="Cidade" p-placeholder="Selecione uma cidade..."
        [p-show-required]="true" [p-required]="true" (p-change)="onChangeCidade($event)"
        [p-options]="cidadesOptions" p-help="Informe uma cidade válida." p-name="cidadeSelect">
      </po-combo>
      <po-button class="po-lg-3 po-mt-4" p-label="Gerar Relatório" (p-click)="geraReportEmpresaRpa()"           [p-loading]="loading"></po-button>
      <div class="po-lg-12 po-md-9 po-sm-8">
        <po-radio-group class="po-lg-12 po-mt-4" [(ngModel)]="tipoFiltro" [p-show-required]="true" [p-required]="true"
            name="radioGroupBasic" p-label="Filtrar por" [p-columns]="4" [p-options]="[
                { label: 'Com Emissão', value: '0' },
                { label: 'Sem Emissão', value: '1' },
                { label: 'Erro de Emissão', value: '2' },
                { label: 'Todas', value: '3' }
              ]">
        </po-radio-group>
      </div>
      <br />

      <div class="po-lg-11 po-md-9 po-sm-8">
        <br />
        <p class="po-font-text-large">Nesta etapa o sistema tentará realizar as seguintes
          operações:
          <br />
          <br />
        </p>
        <p><b> &nbsp;&nbsp; - Localizar as empresas sem a certidão selecionada.</b></p>
        <p><b> &nbsp;&nbsp; - Fazer o download do arquivo em .cvs.</b></p>


      </div>

    </po-container>
  </div>
</div>
</po-modal>

<po-modal #modalRpa p-size="xl" p-title="Arquivos RPA Disponíveis" p-icon="an an-tray-arrow-down" p-click-out="false">

  <p class="po-font-subtitle">Esses documentos são processados pelos sistemas de automação <b
  class="text-green">DevSmart.</b></p>
  <p class="po-font-text-large"><b>{{selectEmpresa?.razaoSocial}}</b></p>

  <br>
    <p class="po-font-text-large">Arquivos disponíveis para download:</p>

    <br>

      <po-table #orcamentoTable p-container="border" [p-columns]="rpaColumns" class="po-lg-12" #wppTable
        [p-selectable]="true" [p-single-select]="true" [p-items]="rpaTableItens" [p-actions]="rpaActions"
        [p-spacing]="poTableColumnSpacing" [p-show-more-disabled]="!rpaMoreItens" p-striped="true" p-text-wrap="true"
        p-container="border" p-hide-columns-manager="true">
        <ng-template p-table-column-template [p-property]="'key'" let-value>
          <span [innerText]="value" class="po-font-text-large-bold"></span>
        </ng-template>
      </po-table>
      <br />
      <br />
      <div class="po-row po-mt-3">
        <p class="po-font-text-large po-mt-1">Os arquivos são processados e disponibilizados conforme
          disponibilidade dos RPAs de automção registrados no sistema.
        </p>
      </div>
      <po-modal-footer>
        <po-button p-label="Atualizar" p-kind="secondary" (p-click)="atualizarRpa()"> </po-button>
        <po-button p-label="Fechar" p-kind="primary" (p-click)="poModalComponent.close()"> </po-button>
      </po-modal-footer>
    </po-modal>


    <po-modal #modalCndRpa p-size="xl" p-title="Processamento de Certidões" p-icon="an an-tray-arrow-down"
      p-click-out="false">

      <p class="po-font-subtitle">Requisição de Processamento de Certidões <b class="text-green">DevSmart.</b></p>
      <p class="po-font-text-large">Empresa selecionada: <b>{{selectEmpresa?.razaoSocial}}</b></p>
      <hr>

        <p class="po-font-text-large">Selecione as certidões que deseja processar:</p>
        <br>

          <div class="po-row">
            <po-checkbox-group #CndGroup class="po-lg-12" name="system" p-label="Certidões diponíveis"
              [p-options]="systemOptions">
            </po-checkbox-group>
          </div>

          <div class="po-row po-mt-3">
            <p class="po-font-text-large po-mt-1">Os arquivos são processados e disponibilizados conforme
              disponibilidade dos RPAs de automção registrados no sistema.
            </p>
          </div>
          <po-modal-footer>
            <po-button p-label="Cancelar" p-kind="secondary" (p-click)="modalCndRpa.close()"> </po-button>
            <po-button p-label="Processar" p-kind="primary" (p-click)="processaCnd()"> </po-button>
          </po-modal-footer>
        </po-modal>

        <po-modal #modalPendencias p-size="xl" p-title="Relatório de Pendências" p-icon="an an-computer-tower"
          p-click-out="false">

          <p class="po-font-subtitle">Relatório de Pendências <b class="text-green">Receita Federal.</b></p>
          <p class="po-font-text-large">Empresa: <b>{{selectEmpresa?.razaoSocial}}</b></p>
          <p class="po-font-text-large">CNPJ: <b>{{selectEmpresa?.cnpj}}</b></p>

          <br>
            <po-divider></po-divider>

            @if (isLoadingPendencias) {
              <div class="loading-message">
                Aguarde. Estamos buscando o Relatório de Situação Fiscal no Sistema Integra Contador...
              </div>
            }

            @if (pdfUrlPendencias && !isLoadingPendencias) {
              <div class="pdf-container">
                <iframe [src]="pdfUrlPendencias" class="pdf-iframe" type="application/pdf"></iframe>
              </div>
            }

            <po-modal-footer>
              <po-button p-label="Fechar" p-kind="primary" (p-click)="poModalPendenciasComponent.close()"> </po-button>
            </po-modal-footer>
          </po-modal>

          @if (isLoading) {
            <po-loading-overlay></po-loading-overlay>
          }
